import router from '@/app/app-routes';
import store from '@/app/app-state';
import { computed, ref } from '@vue/composition-api';
import Vue from 'vue';
import moment from 'moment';
import { PICKER_DOCUMENTS_STORE_MODULE_NAME } from './pickerDocumentsStoreModule';

const routeData = Vue.observable({ params: {}, query: {} });

router.afterEach((route) => {
  routeData.params = route.params;
  routeData.query = route.query;
});

export function usePickerDocumentsList() {
  const documentsPreviewRef = ref(null);

  const isOpenDateDialog = ref(false);
  const date = ref(moment().format('YYYY-MM-DD'));

  const openDateDialog = () => {
    isOpenDateDialog.value = !isOpenDateDialog.value;
  };

  const previewFileTable = (url) => {
    documentsPreviewRef.value.open(url);
  };

  const previewFileInServer = async () => {
    const {
      data: { url },
    } = await store.dispatch(`${PICKER_DOCUMENTS_STORE_MODULE_NAME}/generatePickerDocuments`, {
      preview: true,
      date: date.value,
    });
    documentsPreviewRef.value.open(url);
  };

  const generatePickerDocuments = async () => {
    const {
      data: { url },
    } = await store.dispatch(`${PICKER_DOCUMENTS_STORE_MODULE_NAME}/generatePickerDocuments`, {
      preview: false,
      date: date.value,
    });
    window.location.href = url;
  };

  const fetchPickerDocumnets = (params) => {
    store.dispatch(`${PICKER_DOCUMENTS_STORE_MODULE_NAME}/fetchPickerDocumnets`, params);
  };

  const meta = computed(() => store.state[PICKER_DOCUMENTS_STORE_MODULE_NAME].meta);

  const data = computed(() => store.state[PICKER_DOCUMENTS_STORE_MODULE_NAME].data);

  const changePage = (page) => {
    router.replace({ query: { page } });
    fetchPickerDocumnets({
      page,
    });
  };

  fetchPickerDocumnets({
    page: routeData.query.page || 1,
  });

  const deleteFile = async ({ id }) => {
    await store.dispatch(`${PICKER_DOCUMENTS_STORE_MODULE_NAME}/deleteDocument`, { id });
    fetchPickerDocumnets({
      page: routeData.query.page || 1,
    });
  };

  return {
    meta,
    data,
    changePage,
    documentsPreviewRef,
    previewFileTable,
    previewFileInServer,
    generatePickerDocuments,
    isOpenDateDialog,
    openDateDialog,
    date,
    deleteFile,
  };
}
